import * as constants from './constants';

export const setState = (data) => ({
	type: constants.SET_STATE,
	payload: { data },
});
